import { ClipLoader } from "react-spinners";
const LoaderSpinner=(props)=>{
return (
        <>
          <div  className="loader-container">
            <ClipLoader color={props.color || '#D71226'} size={props.size || 30} />
           </div>
       
        </>
    )

}

export  default LoaderSpinner;